/* global rp$, document, window */

var THE_SCRIPT = function () {

	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the OEM Vehicle Picker Categories Module
	 * -----------------------------------------
	 * @section oem_vehicle_picker_js
	 ********************************************/
	(function OemVehiclePickerCategoriesModule() {
		$onReady({
			rp$, window,
			label: 'oem_vehicle_picker_categories',
			fn: function () {
				let $category_links = rp$.find('.top-level-category');

				rp$.each($category_links, (index, $category_link) => {

					// Add listeners to expand the corresponding subcategories menu for each category
					$category_link.addEventListener('click', () => {
						let activeSubcategoryMenu = rp$.find('.subcategories-row')[0];

						if (activeSubcategoryMenu) {
							// Remove existing subcategory menu in preparation for the new one
							activeSubcategoryMenu.remove();

							let activeMenuCategoryName = activeSubcategoryMenu.getAttribute('data-category-url-name');
							let existingCategoryLink = rp$.find('.top-level-category[data-category-url-name="' + activeMenuCategoryName + '"]')[0];
							existingCategoryLink.classList.remove('selected');

							// We only want to create the subcategory row if the click was on a new category
							if (activeMenuCategoryName !== $category_link.getAttribute('data-category-url-name')) {
								$category_link.classList.add('selected');
								insertSubcategoryRow($category_link);
							}
						} else { // Create a new subcategory menu if one isn't currently open on the page
							$category_link.classList.add('selected');
							insertSubcategoryRow($category_link);
						}
					});
				});
			},
		});

		function createSubcategoryRow({subcategories, categoryName, categoryUrlName, categoryUrl}) {
			const tableRow = document.createElement('tr');
			const tableCell = document.createElement('td');
			const subcategoriesContainer = document.createElement('div');

			tableRow.className = 'subcategories-row';
			tableRow.setAttribute('data-category-url-name', categoryUrlName);
			tableCell.setAttribute('colspan', 4);
			subcategoriesContainer.className = 'subcategory-container';
			subcategoriesContainer.style.maxHeight = '30em';
			subcategoriesContainer.style.overflowY = 'auto';

			// Create link to top-level category page
			let $subcategoryRowHeading = document.createElement('a');
			$subcategoryRowHeading.href = categoryUrl;
			$subcategoryRowHeading.innerText = categoryName;
			$subcategoryRowHeading.className = 'category-title';

			subcategoriesContainer.append($subcategoryRowHeading);
			tableCell.append(subcategoriesContainer);
			tableRow.append(tableCell);

			// Create subcategory links list if data is available
			let all_subcategories = '';
			all_subcategories = JSON.parse(subcategories);

			if (Array.isArray(all_subcategories)) {
				let $subcategoryList = createSubcategoryLinksList(all_subcategories, categoryUrl);
				subcategoriesContainer.append($subcategoryList);
			}

			return tableRow;
		}

		function createSubcategoryLinksList(subcategories, categoryUrl) {
			const $subcategoryList = document.createElement('ul');
			$subcategoryList.style.width = '100%';
			$subcategoryList.style.display = 'flex';

			subcategories.forEach((subcategory) => {
				let $subcategoryLink = document.createElement('li');
				$subcategoryLink.innerHTML = `<a href="${categoryUrl}--${subcategory.url}">${subcategory.ui}</a>`;
				$subcategoryList.append($subcategoryLink);
			});

			return $subcategoryList;
		}

		function insertSubcategoryRow(category_link) {
			let new_row = createSubcategoryRow({
				subcategories: category_link.getAttribute('data-subcategories'),
				categoryName: category_link.getAttribute('data-category-ui'),
				categoryUrl: category_link.getAttribute('data-category-url'),
				categoryUrlName: category_link.getAttribute('data-category-url-name')
			});

			let current_row = category_link.closest('tr');

			// Insert the new subcategory row directly after the current row
			if (new_row && current_row) {
				current_row.parentNode.insertBefore(new_row, current_row.nextSibling);
			}
		}
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
